import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { DownloadSecurityContainerDataProviderFactory } from '../factory/DownloadSecurityContainerDataProviderFactory';
import { DownloadSecurityContainerBaseDataProvider } from '../dataProvider/DownloadSecurityContainerBaseDataProvider';
import { DownloadSecurityContainerWindowData } from '../types/download-security-container-data';

export class DownloadSecurityContainerRepository extends BaseWebComponentRepository {
  public dataProviderFactory: DownloadSecurityContainerDataProviderFactory;
  public dataProvider: DownloadSecurityContainerBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DownloadSecurityContainerDataProviderFactory(),
    });
  }

  public async getDownloadSecurityContainerData(): Promise<DownloadSecurityContainerWindowData> {
    return this.dataProvider.getDownloadSecurityContainerData();
  }

  /**
   *
   * @param packageId
   */
  public async getDownloadSecurityContainerLinks(packageId: string): Promise<DownloadSecurityContainerWindowData> {
    return this.dataProvider.getDownloadSecurityContainerLinks(packageId);
  }
}
